// Walk up the parent_id chain of a location and return an array of names
// from root → leaf. E.g. ["Garage", "Top Shelf"].
// `locations` is the flat array fetched from /api/locations.
export function locationPath(locations, locationId) {
  if (!locationId || !Array.isArray(locations) || locations.length === 0) return [];
  const byId = new Map(locations.map((l) => [l.id, l]));
  const path = [];
  const seen = new Set();
  let current = byId.get(locationId);
  while (current && !seen.has(current.id)) {
    seen.add(current.id);
    path.unshift(current.name);
    current = current.parent_id ? byId.get(current.parent_id) : null;
  }
  return path;
}

// Pretty-print: "Garage › Top Shelf". Empty string when no path.
export function formatLocationPath(locations, locationId, separator = " › ") {
  return locationPath(locations, locationId).join(separator);
}
